export default __webpack_public_path__ + "static/media/Battery_image.2bc28d07.jpg";